<template>
    <b-container>
        <div class="teams">
            <h1>Class</h1>
            <div>
                <router-link v-if="isAdmin" :to="{ name: 'NewSrc' }" class
                    >+Add Class</router-link
                >
            </div>
            <b-col  class="my-1">
                <b-form-group
                label="Filter"
                label-for="filter-input"
                label-cols-sm="1"
                label-size="sm"
                class="mb-0"
                >
                <b-input-group size="sm">
                    <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                    ></b-form-input>

                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
                </b-form-group>
            </b-col>

            <b-table
                v-cloak
                responsive
                :fields="fields"
                :items="classes"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                @filtered="onFiltered"
                >
                <template slot="cell(name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditClass', params: { id: row.item.uuid } }"
                    >{{ row.item.name }}</b-link
                    >
                  
                </template>
                 
                <template slot="cell(active)" slot-scope="row">
                   
                   <b-form-radio-group
                    :id="row.index.toString()"
                    :value="row.item.active"
                    v-model="row.item.active"
                    @change="updateClass(row.item)"
                    >
                    <b-form-radio :value="true">True</b-form-radio>
                    <b-form-radio :value="false">False</b-form-radio>
                    </b-form-radio-group>
                </template>
                </b-table>
                <b-row>
                <b-col md="6" class="my-1">
                    <b-pagination
                    :total-rows="classes.length || 0"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                    />
                </b-col>
                </b-row>
        </div>
    </b-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ClassService from "@/services/ClassService";

export default {
    name:"ClassList",
    data(){
        return {
             fields: [
            { key: "name", label: "Class", sortable: true },
            { key: "teacher_name", label: "Teacher" },
            { key: "school_name", label: "School" },
            { key: "active", label: "Active" },
           
        ],
        currentPage: 1,
        perPage: 5,
        filter: null,
        classes:[]
        }
    },
    methods:{
        ...mapActions({
            REMOVE_TEAM_ID: "cluster/REMOVE_TEAM_ID",
            ADD_TEAM_ID: "cluster/ADD_TEAM_ID",
        }),
        stopClick() {},
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async fetchClasses(){
           var tmp = await ClassService.getClasses();
           this.classes = tmp.data.results;
        },
        async updateClass(params) {
            console.log(params);
            const payload = await {
                id: params.id,
                active: params.active,
            };
            await ClassService.updateClass(payload);
        }
    },
    computed: {
        ...mapGetters({
        isAdmin: "auth/isAdmin",
        }),
    },
    created(){
        this.fetchClasses();
    }    
}
</script>